<template>
  <v-card>
    <v-card-title id="calendarHook" class="pa-0">
      <v-toolbar flat color="blue">
        <v-toolbar-title class="white--text">{{ form.id ? '相談予約を変更する' : '相談予約を追加する' }}</v-toolbar-title>
        <v-tooltip v-if="form.id" bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon small
              v-on="on"
              class="mr-2"
              color="red"
              @click="remove">
              <v-icon small>fal fa-trash-alt</v-icon>
            </v-btn>
          </template>
          <span>削除する</span>
        </v-tooltip>
        <v-spacer />
        <v-row dense align="center" justify="end">
          <v-btn-toggle mandatory v-if="!isFixed">
            <v-btn
              :outlined="getCalendarType !== 'event'"
              :depressed="getCalendarType === 'event'"
              color="secondary white--text"
              value="event"
              @click="changeType('event')">顧客予定</v-btn>
            <v-btn
              :outlined="getCalendarType !== 'consult'"
              :depressed="getCalendarType === 'consult'"
              color="secondary white--text"
              value="consult"
              @click="changeType('consult')">相談予約</v-btn>
          </v-btn-toggle>
        </v-row>
        <template v-slot:extension>
          <v-row dense justify="end" align="center" class="mt-5">
            <v-switch v-model="form.allday" label="終日" color="primary" />
          </v-row>
        </template>
      </v-toolbar>
    </v-card-title>
    <v-card-text>
      <v-form lazy-validation ref="form" v-model="form.valid" @submit.prevent="onSubmit">
        <v-row dense>
          <v-col cols="12">
            <v-text-field validate-on-blur
              ref="firstInput"
              v-model="form.summary"
              label="例：留学太郎①"
              :rules="rules.required"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.description"
              label="備考欄"
              prepend-icon="fal fa-comment-alt-edit"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.date"
              v-mask="'####/##/##'"
              label="予定日"
              prepend-icon="fal fa-calendar-edit"
              append-icon="fal fa-calendar-alt"
              :rules="rules.required"
              @click:append="datepick"
              @blur="verifyDate"
            />
            <v-dialog v-model="config.datepicker.status" max-width="290">
              <v-date-picker
                v-model="config.datepicker.input"
                color="amber"
                locale="ja"
                :day-format="date => new Date(date).getUTCDate()"
                @input="datepicked"
              />
            </v-dialog>
          </v-col>
          <template v-if="!form.allday">
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.time.start"
                v-mask="'##:##'"
                label="開始時刻"
                prepend-icon="fal fa-hourglass-start"
                append-icon="fal fa-clock"
                :rules="rules.required"
                @click:append="timepick('start')"
                @blur="verifyTime('start')"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.time.end"
                v-mask="'##:##'"
                label="終了時刻"
                prepend-icon="fal fa-hourglass-end"
                append-icon="fal fa-clock"
                :rules="rules.required"
                @click:append="timepick('end')"
                @blur="verifyTime('end')"
              />
            </v-col>
            <v-dialog v-model="config.timepicker.status" max-width="290">
              <v-time-picker
                v-model="config.timepicker.input"
                format="24hr"
                :min="getTimeMin">
                <v-spacer></v-spacer>
                <v-btn text color="secondary" @click.stop="timepicked">決定する</v-btn>
              </v-time-picker>
            </v-dialog>
          </template>
        </v-row>
      </v-form>
      <confirm ref="confirmer" />
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text
        color="secondary"
        @click.stop="$emit('close')">止める</v-btn>
      <v-spacer></v-spacer>
      <v-btn depressed
        v-if="!form.id"
        color="secondary"
        :disabled="!isValid"
        :loading="isLoading"
        @click.stop="insert">追加する</v-btn>
      <v-btn depressed
        v-if="form.id"
        color="secondary"
        :disabled="!isValid"
        :loading="isLoading"
        @click.stop="update">変更する</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { mask } from 'vue-the-mask'
import confirm from '@/components/modals/confirm'
export default {
  name: 'sasmango-calendar-editor-consult-card',
  directives: { mask },
  components: {
    confirm
  },
  props: [ 'fixed', 'cid', 'arranges', 'date', 'type' ],
  data () {
    return {
      config: {
        status: {
          loading: false,
          active: false,
          searching: false,
          fixed: false
        },
        client: {
          selectable: false
        },
        datepicker: {
          status: false,
          input: ''
        },
        timepicker: {
          status: false,
          type: '',
          input: ''
        }
      },
      meta: {
      },
      store: {
        cid: '',
        attachments: [],
        selected: [],
        arranges: [],
        clients: []
      },
      form: {
        valid: true,
        id: '',
        search: null,
        client: '',
        summary: '',
        description: '',
        date: '',
        time: {
          start: '',
          end: ''
        }
      },
      rules: {
        required: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    onSubmit: function () { return false },
    init: function () {
      this.$set(this.config.status, 'fixed', this.$props.fixed)
    },
    insert: function () {
      this.submit({ type: 'insert' })
    },
    update: function () {
      this.submit({ type: 'update', eventId: this.form.id })
    },
    remove: function () {
      this.$refs.confirmer.open({
        title: '予定の削除',
        message: '登録済みの予定を削除してもよろしいでしょうか？',
        callback: () => { this.submit({ type: 'remove', eventId: this.form.id }) }
      })
    },
    datepick: function () {
      const date = this.$moment(this.form.date)
      this.$set(this.config, 'datepicker', {
        input: date.isValid() ? date.format('YYYY-MM-DD') : '',
        status: true
      })
    },
    datepicked: function () {
      const date = this.$moment(this.config.datepicker.input)
      this.$set(this.form, 'date', date.isValid() ? date.format('YYYY/MM/DD') : (this.$props.date || this.$moment().format('YYYY/MM/DD')))
      this.$set(this.config.datepicker, 'status', false)
    },
    verifyDate: function () {
      const date = this.$moment(this.form.date)
      if (date.isValid()) {
        this.$set(this.form, 'date', date.format('YYYY/MM/DD'))
      } else {
        this.$set(this.form, 'date', this.$props.date ? this.$moment(this.$props.date).format('YYYY/MM/DD') : this.$moment().format('YYYY/MM/DD'))
      }
    },
    timepick: function (type) {
      if (this.form.time[type] != null) {
        this.$set(this.config, 'timepicker', {
          type,
          input: this.form.time[type] || null,
          status: true
        })
      }
    },
    timepicked: function (e) {
      const { type, input } = this.config.timepicker
      if (this.form.time[type] != null) {
        this.$set(this.form.time, type, input)
        this.config.timepicker.status = false
        this.verifyTime(type)
      }
    },
    verifyTime: function (type) {
      const date = this.$moment().format('YYYY-MM-DD')
      const { start, end } = this.form.time
      if (type === 'start') {
        if (start && this.$moment(`${date} ${start}`).isValid()) {
          if (this.$moment(`${date} ${start}`).isAfter(`${date} ${end}`)) {
            this.$set(this.form.time, 'end', this.$moment(`${date} ${start}`).add(1, 'hours').format('HH:mm'))
          }
        } else {
          this.$set(this.form.time, 'start', this.$moment(`${date} ${end}`).subtract(1, 'hours').format('HH:mm'))
        }
        this.$nextTick(() => {
          this.$set(this.form.time, 'start', this.$moment(`${date} ${this.form.time.start}`).format('HH:mm'))
        })
      } else if (type === 'end') {
        if (end && this.$moment(`${date} ${end}`).isValid()) {
          if (this.$moment(`${date} ${end}`).isBefore(`${date} ${start}`)) {
            this.$set(this.form.time, 'start', this.$moment(`${date} ${end}`).subtract(1, 'hours').format('HH:mm'))
          }
        } else {
          this.$set(this.form.time, 'end', this.$moment(`${date} ${start}`).add(1, 'hours').format('HH:mm'))
        }
        this.$nextTick(() => {
          this.$set(this.form.time, 'end', this.$moment(`${date} ${this.form.time.end}`).format('HH:mm'))
        })
      }
    },
    preSubmit: function (req) {
      const { type, eventId } = req
      const { search, summary, description, allday, date, time } = this.form
      const cid = this.store.cid
      const aid = this.$store.getters['author/get']('userid')
      const urls = {
        insert: `${this.$url.api}calendar/insert/consult`,
        update: `${this.$url.api}calendar/update/consult/${eventId}`,
        remove: `${this.$url.api}calendar/remove/item/${eventId}`,
        recurrence: `${this.$url.api}calendar/get/item/${eventId}`
      }
      const fds = {
        arrange: { all_required: true },
        client: { name: search },
        insert: { summary, description, allday, date: this.$moment(date).format('YYYY-MM-DD'), time },
        update: { summary, description, allday, date: this.$moment(date).format('YYYY-MM-DD'), time },
        remove: { name: 'consult', summary },
        recurrence: {}
      }
      if (!this.socket) {
        this.$set(this, 'socket', this.$store.getters['config/get']('socket'))
      }
      if (type && urls[type] && fds[type]) {
        if (this.$refs.form && this.$refs.form.validate()) {
          this.$set(this.config.status, 'loading', true)
          return { type, url: urls[type], fd: fds[type] }
        } else if (type === 'client' && search) {
          this.$set(this.config.status, 'searching', true)
          return { type, url: urls[type], fd: fds[type] }
        } else if (type === 'arrange' && cid) {
          this.$set(this.config.status, 'loading', true)
          return { type, url: urls[type], fd: fds[type] }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { type, url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({
                type,
                data: res.data.data
              })
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const socket = this.$store.getters['config/get']('socket')
      const { type, data } = req || {}
      if (['insert', 'update', 'remove'].includes(type)) {
        if (!socket.connected) {
          socket.connect()
        }
        socket.emit('POST_CALENDAR', Object.assign(req, {
          user: this.$store.getters['author/get']('userid'),
          calendarType: 'consults'
        }), (res) => {
          console.log(res)
          this.$set(this.config.status, 'loading', false)
          this.$emit('done', req)
          this.$emit('close')
        })
      }
    },
    failSubmit: function () {
      this.$set(this.config.status, 'loading', false)
    },
    changeType: function (type) {
      if (type) {
        this.$emit('change', type)
      }
    },
    openForInsert: function (req) {
      const now = this.$moment().add(1, 'h')
      const later = this.$moment().add(2, 'h')
      this.$set(this.store, 'cid', this.$props.cid || '')
      this.$set(this.config.status, 'fixed', false)
      this.$set(this, 'form', {
        valid: true,
        search: null,
        allday: false,
        summary: '',
        description: '',
        date: this.$props.date ? this.$moment(this.$props.date).format('YYYY/MM/DD') : now.format('YYYY/MM/DD'),
        time: {
          start: `${now.format('HH')}:00`,
          end: `${later.format('HH')}:00`
        }
      })
      setTimeout(() => {
        if (this.$refs.firstInput) {
          this.$refs.firstInput.focus()
        }
      }, 500)
    },
    openForUpdate: function (req) {
      const { id, cid, summary, description, start, end } = req || {
        id: '',
        summary: '',
        description: '',
        start: {},
        end: {}
      }
      const isAllday = !start.dateTime
      const startDatetime = this.$moment(start.date || start.dateTime)
      const endDatetime = this.$moment(end.date || end.dateTime)
      this.$set(this.store, 'cid', cid || this.$props.cid || this.$route.params.id || '')
      this.$set(this.config.status, 'fixed', true)
      this.$set(this, 'form', {
        valid: true,
        id,
        search: null,
        summary: summary || '',
        description: description || '',
        allday: isAllday,
        date: startDatetime.isValid() ? startDatetime.format('YYYY/MM/DD') : '',
        time: {
          start: startDatetime.isValid() ? startDatetime.format('HH:mm') : '',
          end: endDatetime.isValid() ? endDatetime.format('HH:mm') : ''
        }
      })
      setTimeout(() => {
        if (this.$refs.firstInput) {
          this.$refs.firstInput.focus()
        }
      }, 500)
    }
  },
  watch: {
    'form.search': function (newVal, oldVal) {
      if (newVal && oldVal && newVal.length < oldVal.length) {
        this.$set(this.store, 'clients', [])
      }
      if (!this.config.status.searching && !this.store.clients.length) {
        this.searchClient()
      }
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isActive () {
      return this.config.status.active
    },
    isValid () {
      return this.form.valid
    },
    isSearching () {
      return this.config.status.searching
    },
    isFixed () {
      return this.$props.fixed
    },
    getClientId () {
      return this.$props.cid
    },
    getCalendarType () {
      return this.$props.type
    },
    isClientSelectable () {
      return this.config.client.selectable
    },
    getClientItems () {
      return this.store.clients.length ? this.store.clients.map(it => {
        return {
          text: `${it.name.replace(',', '')}（${it.kana.replace(',', '')}）`,
          value: it.id
        }
      }) : []
    },
    getCategoryMetaItems () {
      return Object.keys(this.$mango.reminders)
    },
    getLabelMetaItems () {
      return this.$mango.reminders[this.form.category] ? this.$mango.reminders[this.form.category].labels.items : []
    },
    getTimeMin () {
      const { type } = this.config.timepicker
      if (type === 'start') {
        return null
      } else {
        return this.form.time.start
      }
    },
    getTimeMax () {
      const { type } = this.config.timepicker
      if (type === 'start') {
        return this.form.time.end
      } else {
        return null
      }
    }
  }
}
</script>